export const selectDuelSession = (state: RootState) => state.duelSession;
